import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "../src/scss/animate.min.css";
import { SettingsProvider } from "src/context/SettingsContext";
import AuthProvider from "src/context/Auth";
import { ChartDataProvider } from "src/views/pages/Portfolio/ChartdataContext";
import { HelmetProvider } from "react-helmet-async";
import { SnackbarProvider } from "src/context/SnackbarProvider";
import { getActingAsHeader } from "src/utils/actingAs";

// Global, not per-helper: a lot of pages (e.g. the Transactions table components) call `axios`
// directly instead of going through src/Apiconfig/service's helpers, which is where the
// acting-as header was originally added - those calls silently never carried it. An axios
// request interceptor applies to every call regardless of which file makes it, so this is the
// one place that actually guarantees X-Acting-As-User-Id reaches every outgoing request.
axios.interceptors.request.use((config) => {
  const actingAsUserId = getActingAsHeader()["X-Acting-As-User-Id"];
  if (actingAsUserId) {
    // axios v1's config.headers is an AxiosHeaders instance, not a plain object - spreading it
    // into a new plain object (the previous approach here) silently drops it, since AxiosHeaders
    // stores entries internally rather than as plain enumerable own properties. `.set()` is the
    // documented way to add a header without disturbing whatever's already on the instance.
    if (config.headers && typeof config.headers.set === "function") {
      config.headers.set("X-Acting-As-User-Id", actingAsUserId);
    } else {
      config.headers = { ...config.headers, "X-Acting-As-User-Id": actingAsUserId };
    }
  }
  return config;
});

ReactDOM.render(
  <HelmetProvider>
    <SettingsProvider>
      <AuthProvider>
        <SnackbarProvider>
        <ChartDataProvider>
          <App />
        </ChartDataProvider>
        </SnackbarProvider>
      </AuthProvider>
    </SettingsProvider>
  </HelmetProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
